goog.provide('el8.ptdata.plrCollaborators');

goog.require('el8.data.referencedUsers');
goog.require('el8.model.base');


/**
 * Relationships with other physicians who are collaborating
 * on this person and the patient_ids/practice_id for those charts/practices
 */
el8.ptdata.plrCollaborators = (function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    // This is not really an el8_Entity. It doesn't have its own ID
    // or model_class, etc... but things like asSoyMap are dependent on
    // el8_Entity, so we have to re-use that
    _class.inheritsFrom(el8_Entity);

    _class.addIntProperty('patientId'); // this will be our key

    _class.addIntProperty('practiceId');
    _class.addStringProperty('practiceName');
    _class.addStringProperty('physicianName');

    _class.addProperty('specialtyCategories');
    
    // last visit date in the other practice
    _class.addDateTime('lastSeen');

    // when did my practice last review this collaborator's clinical profile
    _class.addDateTime('lastReviewTime');
    _class.addIntProperty('lastReviewUserId');

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);

        mapped['lastReviewUserName'] = this.getLastReviewUserId() ?
            el8.data.referencedUsers.getById(this.getLastReviewUserId()).getFullName() : '';

        return mapped;
    };

    var that = new el8_EntitySet({
        key: 'patientId',
        model: function(spec) { return new _class(spec); },
        urlLoad: el8Globals.PATIENT_PATH + 'collaborators/'
    });

    // Note that practiceId is not guaranteed to be unique
    // (even though it's intended to be). If there are multiple matches,
    // this will just return an arbitrary one.
    that.getByPracticeId = function(practiceId) {
        return _.find(that.all(), function(collab) {
            return collab.getPracticeId() === practiceId;
        });
    };

    that.getPracticeIds = function() {
        return that.all().map(function(collab) {
            return collab.getPracticeId();
        });
    };

    return that;

})();
